import { useEffect, useState } from 'react';
import AOS from 'aos';
import { NavbarSec, FooterSec } from './Sections';
import { DynamicTitle, ScrollToTop, ToTopBtn, WebRoutes, Loading, WhatsAppBtn } from './Components';
import './Styles/shine-on-hover.css';
import 'react-loading-skeleton/dist/skeleton.css';
import './App.css';

const App = () => {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        AOS.init({
            duration: 800,
        });
    }, []);

    return (
        <>
            {isLoading ? (
                <Loading
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                />
            ) : (
                <>                
                    <div className="MAIN-WRAPPER">
                        <NavbarSec />
                        <div className="App">
                            <WebRoutes />
                            <FooterSec />
                            <ToTopBtn />
                        </div>
                    </div>
                    <WhatsAppBtn />
                    <ScrollToTop />
                    <DynamicTitle />
                </>
            )}
        </>
    );
}

export default App;
